import { ApiService } from '../shared/services/api-service/api.service';
import { IStoreMetaData } from './interface/meta-collection.interface';

class MetaCollection {
    async postMetaCollection(storeMetaData: IStoreMetaData) {
        try {
            const storeMetaDataApiResponse: Response = await ApiService.callStoreMetaDataApi(storeMetaData);
            const storeMetaDataObject: any = await storeMetaDataApiResponse.json();
            return storeMetaDataObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const MetaCollectionService = new MetaCollection();
